import { Component, signal, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CrustLogoComponent } from '../../shared/svg/crust-logo';
import { SparkleComponent } from '../../shared/components/sparkle/sparkle';

@Component({
	selector: 'app-splash',
	imports: [CrustLogoComponent, SparkleComponent, RouterLink],
	templateUrl: './splash.html',
	styleUrl: './splash.scss'
})
export class Splash {

	// Signal to track if avatar is clicked (showing surprised state)
	private isSurprised = signal(false);

	// Computed property to determine which avatar image to display
	avatarImage = computed(() => {
		// Show surprised image when clicked
		if (this.isSurprised()) {
			return 'assets/images/avatar/Crustopher-Surprised.png';
		}
		// Show sad image when goal is not reached
		return 'assets/images/avatar/Crustopher-Neutral.png';
	});

	// Handle avatar click to show surprised state
	onAvatarClick() {
		this.isSurprised.set(true);
		// Revert back to previous state after 500ms
		setTimeout(() => {
			this.isSurprised.set(false);
		}, 500);
	}

}
